import React from "react";
import styles from "./PurchaseOrder.module.css";

const PurchaseOrder = ({ data, data2 }) => {
  const stageMap = Object?.fromEntries(
    data2.map((stage) => [stage.id, stage.stage])
  );

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const totalTaxableAmountData =
    data.orderItemDetails &&
    data.orderItemDetails?.reduce(
      (acc, item) => acc + parseFloat(item?.unit_rate) * parseFloat(item?.qty),
      0
    );
  const totalAmountData =
    data.orderItemDetails &&
    data.orderItemDetails?.reduce(
      (acc, item) => acc + parseFloat(item?.amount),
      0
    );

  const formatNumberWithBreaks = (num, isCurrency = false) => {
    if (!num && num !== 0) return "-";
    const options = isCurrency
      ? {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      : {};
    return parseFloat(num)
      .toLocaleString("en-IN", options)
      .replace(/,/g, ",\u200B");
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.header}>
        <div className={styles.logoSection}>
          <img
            src="https://bermadimsapi.disctesting.in/uploads/logo/8e08ec4e6348fc2fe1f64ae147db7496.jpeg"
            alt="BERMAD"
            className={styles.logo}
          />
          <div className={styles.companyName}>
            BERMAD INDIA Private Limited.
          </div>
        </div>
        <div className={styles.addressRight}>
          <h2 className={styles.orderTitle}>Order Details</h2>
          <div>
            <strong>Project Name:</strong> {data?.project?.project_name}
          </div>
          <div>
            <strong>Project Code:</strong> {data?.project?.project_code}
          </div>
        </div>
      </div>

      <div className={styles.blueBar}></div>

      <table className={styles.orderHeader}>
        <thead>
          <tr>
            <th style={{ width: "30%", textAlign: "left" }}>SO No:</th>
            <th style={{ width: "20%", textAlign: "left" }}>Order Date:</th>
            <th style={{ width: "20%", textAlign: "left" }}>Customer:</th>
            <th style={{ width: "30%", textAlign: "left" }}>
              Order Reference No:
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.order_no || "_"}
            </td>
            <td className={styles.cellNowrap} style={{ textAlign: "left" }}>
              {formatDate(data?.order_date) || "_"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.company?.company_name || "_"}
            </td>
            <td className={styles.cellWrap} style={{ textAlign: "left" }}>
              {data?.order_ref_no || "_"}
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.addressTable}>
        <thead>
          <tr>
            <th className={styles.addressHeader}>Bill To:</th>
            <th className={styles.addressHeader}>Ship To:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={styles.addressCell}>
              <div className={styles.addressContent}>
                {data?.billing_address}
              </div>
            </td>
            <td className={styles.addressCell}>
              <div className={styles.addressContent}>
                {data?.shipping_address}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable}>
        <thead>
          <tr>
            <th>GST No:</th>
            <th>PAN No:</th>
            <th>Status:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data?.company?.gst_no || "-"}</td>
            <td>{data?.company?.pan_no || "-"}</td>
            <td>{data?.status?.split("_").join(" ").toUpperCase() || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.termsTable} style={{ marginTop: "10px" }}>
        <thead>
          <tr>
            <th>Remark:</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data?.remark || "-"}</td>
          </tr>
        </tbody>
      </table>

      <table className={styles.catalogTable}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr No.</th>
            <th style={{ width: "20%" }}>Item Code</th>
            <th style={{ width: "25%" }}>Customer Desc</th>
            <th style={{ width: "15%" }}>UOM</th>
            <th style={{ width: "10%" }}>QTY</th>
            <th style={{ width: "10%" }}>Invoice QTY</th>
            <th style={{ width: "12%" }}>Unit Price</th>
            <th style={{ width: "8%" }}>GST %</th>
            <th style={{ width: "12%" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {data?.orderItemDetails
            ?.filter((row) => row.is_active)
            .map((item, index) => (
              <React.Fragment key={item.id}>
                <tr>
                  <td className={styles.textCenter}>{index + 1}</td>
                  <td>
                    <div className={styles.itemDescription}>
                      <div className={styles.itemCode}>
                        {item?.item?.item_code || "-"}
                      </div>
                      <div className={styles.itemDesc}>
                        {item?.item?.description || "-"}
                      </div>
                    </div>
                  </td>
                  <td className={styles.cellWrap}>
                    {item?.customer_desc || "-"}
                  </td>
                  <td className={styles.textCenter}>
                    {item?.item?.uom?.uom_name || "-"}
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(item?.qty)}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(item?.invoice_qty)}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(item?.unit_rate, true)}
                    </div>
                  </td>
                  <td className={styles.textCenter}>
                    <div className={styles.numberWrapper}>
                      {item?.gst_percentage || "-"}
                    </div>
                  </td>
                  <td className={styles.textRight}>
                    <div className={styles.numberWrapper}>
                      {formatNumberWithBreaks(item?.amount, true)}
                    </div>
                  </td>
                </tr>
                {item?.buy_item_details?.map((subItem, subIndex) => (
                  <tr key={subItem?.id} className={styles.subItemRow}>
                    <td className={styles.textCenter}>{`${index + 1}.${
                      subIndex + 1
                    }`}</td>
                    <td>
                      <div className={styles.subItemCode}>
                        {subItem?.item_code || "-"}
                      </div>
                      <div className={styles.subItemDesc}>
                        {subItem?.item_desc || "-"}
                      </div>
                    </td>
                    <td>-</td>
                    <td className={styles.textCenter}>{subItem?.uom || "-"}</td>
                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {formatNumberWithBreaks(subItem?.qty)}
                      </div>
                    </td>
                    <td className={styles.textRight}>
                      <div className={styles.numberWrapper}>
                        {formatNumberWithBreaks(subItem?.invoice_qty)}
                      </div>
                    </td>
                    <td className={styles.textRight}>-</td>
                    <td className={styles.textCenter}>-</td>
                    <td className={styles.textRight}>-</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
        </tbody>
      </table>

      <div className={styles.totalsSectionRight}>
        <table className={styles.totalsTable}>
          <tbody>
            <tr>
              <td className={styles.totalLabel}>TAXABLE AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalTaxableAmountData
                    ? totalTaxableAmountData.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
              </td>
            </tr>
            <tr>
              <td className={styles.totalLabel}>GST AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalAmountData - totalTaxableAmountData
                    ? (totalAmountData - totalTaxableAmountData).toLocaleString(
                        "en-IN",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )
                    : "0.00"}
                </div>
              </td>
            </tr>
            <tr className={styles.grandTotal}>
              <td className={styles.totalLabel}>TOTAL AMOUNT:</td>
              <td className={styles.totalValue}>
                <div className={styles.scientificNumber}>
                  {totalAmountData
                    ? totalAmountData.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles.clearFix}></div>
    </div>
  );
};

export default PurchaseOrder;
